import { Link } from 'react-router'
import { Section, SectionWrapper } from '@/components/layout/Section'
import { Seo } from '@/components/seo/Seo'

/**
 * `/outbound` — the one route with no source.
 *
 * The mirror captured Webflow's 404 page for this URL, so there is nothing to
 * migrate. It stays a real route rather than a 404 so the nav and the redirect
 * map keep working; see MIGRATION-PLAN.md §8.
 */
export function OutboundStub() {
  return (
    <>
      <Seo title="Singulate Outbound" path="/outbound" noindex />
      <Section surface="dark" padding="lg" paddingTop="3xl" paddingBottom="xl">
      <SectionWrapper layout="stack" centered width="content">
        <h1 className="m-0 text-center text-white">Singulate Outbound</h1>
        <p className="m-0 text-center text-dark-blue-50">
          This page is being rebuilt. In the meantime,{' '}
          <Link to="/demo" className="text-white underline">
            book a demo
          </Link>{' '}
          or read{' '}
          <Link to="/post/announcing-singulate-outbound" className="text-white underline">
            the announcement post
          </Link>
          .
        </p>
      </SectionWrapper>
    </Section>
    </>
  )
}
